import React from 'react';
import { Typography, Grid, Card, CardContent } from '@mui/material';
import StatCard from './StatCard';
import { formatCurrency, formatNum } from './dashboardUtils';
import { getCardMeta, isMoneyTitle } from './dashboardConfig';

/**
 * One block of dashboard cards. `items` is the API shape `[{ title, sub_title, value }]`,
 * so every dashboard block (leads, sales, tasks, meetings, DBAs…) goes through here.
 */
const DashboardCardSection = ({ sectionKey, heading, items, loading }) => {
  if (!Array.isArray(items)) return null;

  const title = heading && (
    <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1.5, color: 'text.secondary' }}>
      {heading}
    </Typography>
  );

  if (items.length === 0) {
    return (
      <>
        {title}
        <Card variant="outlined" sx={{ mb: 3 }}>
          <CardContent sx={{ textAlign: 'center', color: 'text.secondary' }}>
            <Typography variant="body2">No data found.</Typography>
          </CardContent>
        </Card>
      </>
    );
  }

  return (
    <>
      {title}
      <Grid container spacing={2} sx={{ mb: 3 }}>
        {items.map((item) => {
          const { Icon, color, drilldown } = getCardMeta(item.title, sectionKey);
          return (
            <Grid item xs={12} sm={6} md={4} lg={3} xl={2} key={item.title} sx={{ minWidth: 0 }}>
              <StatCard
                title={item.title}
                subtitle={item.sub_title}
                value={isMoneyTitle(item.title) ? formatCurrency(item.value ?? 0) : formatNum(item.value)}
                icon={<Icon />}
                color={color}
                drilldown={drilldown}
                loading={loading}
              />
            </Grid>
          );
        })}
      </Grid>
    </>
  );
};

export default DashboardCardSection;
